import React from "react";
import Icon from "../Icon/icon";

const QuantitySelector = ({ onChange, value, maxValue = 1000, minValue = 1 }) => {
    const updateQuantity = (newQuantity) => {
        if (newQuantity >= minValue && newQuantity <= maxValue) {
            onChange(newQuantity);
        }
    };

    const handleQuantityChange = (amount) => {
        updateQuantity(value + amount);
    };

    return (
        <div className="quantity-selector">
            <button
                type="button"
                onClick={() => handleQuantityChange(-1)}
                className="quantity-selector__item"
                disabled={value <= minValue}
            >
                <Icon icon="minus" size="1.1rem" />
            </button>
            <input
                value={value}
                readOnly
                className="quantity-selector__input"
            />
            <button
                type="button"
                onClick={() => handleQuantityChange(1)}
                className="quantity-selector__item"
                disabled={value >= maxValue}
            >
                <Icon icon="plus" size="1.1rem" />
            </button>
        </div>
    );
};

export default QuantitySelector;
